const {fromJSON} = require( 'postcss' );
const {default: formatCSS} = require( 'tailwindcss/lib/lib/formatCSS' );

( function( $ ) {
  'use strict';

  // slider for multiple images
  $( '.slider-for' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    draggable: false,
    asNavFor: '.slider-nav',
    arrows: false,
    infinite: false,
    accessibility: true,
    focusOnChange: true,
  } );
  $( '.slider-nav' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    vertical: true,
    arrows: true,
    draggable: false,
    focusOnSelect: true,
    nextArrow: '<button class="next"></button>',
    prevArrow: '<button class="prev"></button>',
    infinite: false,
    accessibility: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          arrows: false,
          draggable: true,
          variableWidth: true,
        },
      },
    ],
  } );

  $( '.slider' ).on( 'input change', ( e )=>{
    const sliderPosition = e.target.value;
    // Update the width of the foreground image
    $( '.foreground' ).css( 'width', `calc(${sliderPosition}% - 4px)` );
    // Update the position of the slider button
    $( '.slider-button' ).css( 'left', `calc(${sliderPosition}% - 36px)` );
  } );
  $( '.bag_gallery-image' ).on( 'click', function() {
    // Reset the width of the foreground image
    $( '.foreground' ).css( 'width', `calc(50% - 4px)` );
    // Reset the position of the slider button
    $( '.slider-button' ).css( 'left', `calc(50% - 36px)` );
    // Reset the position of the slider bar
    $( '.slider' ).val( '50' );
  } );

  // mobile filter toggles
  $( '.bag_mobile-filter-toggle' ).on( 'click', function() {
    $( '.bag_mobile-filter' ).toggleClass( 'bag_active' );
  } );
  $( '.bag_mobile-filter-exit' ).on( 'click', function() {
    $( '.bag_mobile-filter' ).toggleClass( 'bag_active' );
  } );

  // iframe popup functionality
  $( '.bag_init-popup' ).magnificPopup( {
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  } );

  if ( $( '.single-ll_bag' ).length > 0 ) {
    // if user arrived at this page by a filtered result, update back link to go back to the filtered result
    let backUrl = localStorage.getItem( 'backToBag' );
    if ( backUrl === null ) {
      backUrl = '/before-and-after/';
    }
    $( '.bag_sidebar-back-btn a' ).attr( 'href', backUrl );

    // if the result is nsfw, show the nsfw popup warning
    if ( $( '.bag_single-page-section' ).hasClass( 'is-nsfw' ) && localStorage.getItem( 'bag-nsfw-safe' ) !== 'true' ) {
      $.magnificPopup.open( {
        closeOnBgClick: false,
        items: {
          src: '#ll-bag-nsfw-popup',
          type: 'inline',
        },
        callbacks: {
          open: function() {
            $( 'body' ).addClass( 'bag-no-scroll' );
          },
          close: function() {
            $( 'body' ).removeClass( 'bag-no-scroll' );
          },
        },
      } );
    }
  }

  if ( $( '.bag_archive-section' ).length > 0 && !window.location.search ) {
    // if the results are nsfw, show the nsfw popup warning
    if ( $( '.is-nsfw' ).length > 0 && localStorage.getItem( 'bag-nsfw-safe' ) !== 'true' ) {
      $.magnificPopup.open( {
        closeOnBgClick: false,
        items: {
          src: '#ll-bag-nsfw-popup',
          type: 'inline',
        },
        callbacks: {
          open: function() {
            $( 'body' ).addClass( 'bag-no-scroll' );
          },
          close: function() {
            $( 'body' ).removeClass( 'bag-no-scroll' );
          },
        },
      } );
    }
  }

  // custom close button functionality for bag modal, because it wasn't working normally
  $( '.ll-bag-modal__close' ).on( 'click', function() {
    if ( $( this ).closest( '.ll-bag-modal' ).hasClass( 'll-bag-nsfw-popup' ) ) {
      localStorage.setItem( 'bag-nsfw-safe', 'true' );
    }
    $( 'body' ).removeClass( 'bag-no-scroll' );
    $( '.mfp-close' ).trigger( 'click' );
  } );

  // if url has parameters, filter the results
  if ( window.location.search ) {
    filterBag( new URLSearchParams( window.location.search ).toString() );
  } else {
    $( '#bag_results-container' ).addClass( 'is-loaded' );
  }

  // if the window is mobile, add aria-hidden to the filter form to make it more accessible with the dropdown trigger
  if ( window.innerWidth < 1024 ) {
    $( '#bag_filter-form' ).attr( 'aria-hidden', true );
  }

  // if the window is mobile, add aria-hidden to the filter form to make it more accessible with the dropdown trigger
  $( window ).on( 'resize', function() {
    if ( window.innerWidth < 1024 ) {
      $( '#bag_filter-form' ).attr( 'aria-hidden', true );
    } else {
      $( '#bag_filter-form' ).removeAttr( 'aria-hidden' );
    }
  } );

  // if a checkbox is changed, update the form and add a pill button showing the new filter
  document.querySelectorAll( '.bag_filter-form input[type="checkbox"]' ).forEach( ( el ) => {
    el.addEventListener( 'change', () => {
      // check to see if changed checkbox has a pill
      // if it does click the pill to remove the item,
      // else create the pill and then submit the form
      const checkboxes = document.querySelectorAll( '.bag_filter-form input[value="'+el.value+'"]' );
      const currentButton = document.querySelector( 'button[value="'+el.value+'"]' );

      if ( $( el ).closest( '.add-to-banner' ).length ) {
        console.log( '.bar_archive-banner label[for="' + $( el ).attr( 'id' ) + '"]' );
        $( '.bar_archive-banner label[for="' + $( el ).attr( 'id' ) + '"], .bag_archive-banner label[for="' + $( el ).attr( 'id' ) + '"]' ).toggleClass( 'is-checked' );
      }

      if ( currentButton ) {
        currentButton.parentElement.remove();
        if ( !$( '.bag_pill-btn' ).length ) {
          $( '.bag_selected-filters' ).removeClass( 'active' );
        }
        form.trigger( 'submit' );
      } else {
        $( '.bag_selected-filters' ).addClass( 'active' );
        const label = document.querySelector( '[for="' +el.id+'"]' );
        const newContent = `<li class="bag-mx-2 bag-mb-3"><button type="button" class="bag_pill-btn bag-inline-flex bag-items-center bag-p-2 bag-text-xs bag-font-medium bag-leading-tight bag-bg-opacity-50 bag-rounded bag-text-brand-charcoal bag-bg-brand-light-gray" name="${el.name.replace( '[]', '' )}" value="${el.value}">
        <span class="sr-only">Remove filter for </span>
        ${label.textContent}
        <svg class="bag-ml-3 bag-w-3 bag-h-3 bag-pointer-events-none bag-text-brand-graphite icon icon-cross-small"><use xlink:href="#icon-cross-small"></use></svg>
        </button></li>`;
        document.querySelector( '.bag_selected-filters ul' ).insertAdjacentHTML( 'beforeend', newContent );
      }
      form.trigger( 'submit' );
    } );
  } );

  // AJAX
  const form = $( '#bag_filter-form' );
  const inputs = $( '.bag_filter-form input' );

  // when the form is submitted, update browser history and get new results
  form.on( 'submit', function( event ) {
    event.preventDefault();

    const formData = new FormData( event.target );
    const urlQuery = new URLSearchParams( formData ).toString();

    history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );
    filterBag( urlQuery );

    const fromUrl = window.location.href;
    localStorage.setItem( 'backToBag', fromUrl );
  } );

  // set up pagination with history
  document.body.addEventListener( 'click', function( event ) {
    const target = event.target;
    if ( target.classList.contains( 'page-numbers', 'nav-button', 'bag_filter-tag' ) ) {
      const page = target;
      const urlQuery = new URLSearchParams( window.location.search );
      urlQuery.set( 'page', page.dataset.value );
      history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
      filterBag( urlQuery.toString() );
      location.href = '#bag_results-container';
    }
  } );

  // When clear all filters is clicked, unset all of the checkboxes, and resubmit the form
  $( '.bag_clear-filter' ).on( 'click', function( e ) {
    e.preventDefault();

    document.querySelectorAll( '.bag_filter-form input[type="checkbox"]' ).forEach( ( el ) => {
      el.checked = false;
    } );

    document.querySelectorAll( '.bag_selected-filters .bag_pill-btn' ).forEach( ( el ) => {
      el.remove();
    } );

    $( '.bag_selected-filters' ).removeClass( 'active' );

    form.trigger( 'submit' );
  } );

  // If there are no pill buttons (i.e. no filters), remove the Clear All Filters button
  if ( $( '.bag_pill-btn' ).length >= 1 ) {
    $( '.bag_clear-filter' ).removeClass( 'hidden' );
  } else {
    $( '.bag_clear-filter' ).addClass( 'hidden' );
  }

  // remove pills when clicked and resubmit form
  $( '.bag_selected-filters' ).on( 'click', '.bag_pill-btn', function( el ) {
    if ( this.classList.contains( 'bag_pill-btn' ) ) {
      const uncheckedInput = document.querySelectorAll( 'input[name="'+this.name+'[]"][value="'+this.value+'"]' );
      $( uncheckedInput ).each( function() {
        $( this )[0].checked = false;
      } );

      const termButton = document.querySelector( 'button[value="'+this.value+'"]' );
      if ( termButton ) {
        termButton.parentElement.remove();
      }

      form.trigger( 'submit' );
    }

    if ( !$( '.bag_pill-btn' ).length ) {
      $( '.bag_selected-filters' ).removeClass( 'active' );
    }
  } );

  // Filter the results with ajax
  function filterBag( query ) {
    $( '#bag_results-container' ).addClass( 'is-filtering' );

    $.ajax( {
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      dataType: 'html',
      data: {
        action: 'll_bag_filter',
        query: query,
      },
      success: function( res ) {
        const data = $.parseJSON( res );

        if ( data.grid ) {
          document.querySelector( '#bag_results-container' ).innerHTML = data.grid;
          document.querySelector( '#bag_results-container' ).insertAdjacentHTML( 'afterBegin', '<h2 class="sr-only">Filtered Results:</h2>' );

          if ( data.paging ) {
            document.querySelector( '.bag_pagination' ).outerHTML = data.paging;
          } else {
            document.querySelector( '.bag_pagination' ).innerHTML = data.paging;
          }

          if ( data.filter ) {
            // document.querySelector( '.bag_selected-filters' ).innerHTML = data.filter;
          }

          if ( $( '.bag_pill-btn' ).length >= 1 ) {
            $( '.bag_clear-filter' ).removeClass( 'hidden' );
          } else {
            $( '.bag_clear-filter' ).addClass( 'hidden' );
          }
        } else {
          document.querySelector( '#bag_results-container' ).innerHTML = '<p class="ll-filter-result-notice mb-12">No results found, please adjust your search</p>';
          document.querySelector( '.bag_pagination' ).innerHTML = '';
        }

        $( '#bag_results-container' ).addClass( 'is-loaded' ).removeClass( 'is-filtering' );

        // if the results are nsfw, show the nsfw popup warning
        if ( $( '.is-nsfw' ).length > 0 && localStorage.getItem( 'bag-nsfw-safe' ) !== 'true' ) {
          $.magnificPopup.open( {
            closeOnBgClick: false,
            items: {
              src: '#ll-bag-nsfw-popup',
              type: 'inline',
            },
            callbacks: {
              open: function() {
                $( 'body' ).addClass( 'bag-no-scroll' );
              },
              close: function() {
                $( 'body' ).removeClass( 'bag-no-scroll' );
              },
            },
          } );
        }
      },
      error: function( err ) {
        console.log( err );
      },
    } );
  }
} )( jQuery );

